import { render } from "./sort-za.svg?vue&type=template&id=4dd41898"
const script = {}
script.render = render

export default script